import React from 'react'
import TooltipAjuda from './TooltipAjuda'
import LinkRetorno from './LinkRetorno';

const Titulo =  ({
  texto, conteudoAjuda, urlRetorno
}) => (
    <div className="col-12 titulo-principal">
        <h1 id="titulo-page" className="tit-desenv">
          <LinkRetorno urlRetorno={urlRetorno}/>
          {texto}
          <TooltipAjuda id='ajudaTitulo' conteudo={conteudoAjuda}/>
          <p className="linha"> </p>
        </h1>
    </div>
)

export default Titulo
